import { render } from "./CatchAll.vue?vue&type=template&id=a114cd6e&bindings={}"
import script from "./CatchAll.vue?vue&type=script&lang=ts"
export * from "./CatchAll.vue?vue&type=script&lang=ts"
script.render = render

export default script